import { Button } from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

import type { RemoveItemParams } from 'features/order/substitution-flow/domain';

import { SFDeleteItemConfirm } from './components';
import { useSubstitutionFlowDeleteItemBtn } from './hooks';
import makeClasses from './SubstitutionFlowDeleteItemBtn.style';

export function SubstitutionFlowDeleteItemBtn(props: RemoveItemParams) {
  const {
    deleteItemLabel,
    isConfirmOpen,
    openConfirm,
    closeConfirm,
    confirmDelete,
  } = useSubstitutionFlowDeleteItemBtn(props);
  const _classes = makeClasses();

  return (
    <>
      <Button
        variant='outlined'
        startIcon={<DeleteOutlineIcon />}
        classes={{ root: _classes.root }}
        onClick={openConfirm}
      >
        {deleteItemLabel}
      </Button>
      <SFDeleteItemConfirm
        open={isConfirmOpen}
        onClose={closeConfirm}
        onConfirm={confirmDelete}
      />
    </>
  );
}
